import { Box, Modal, Slide, Typography } from "@mui/material";
import Image from "../../../../assets/images/default-img.jpg";
import React, { useState, useCallback } from "react";
import "./imageStyle.css";
import { getIcon } from "../../../../utils/iconConfig";
import { useGlobalContext } from "../../../../context/GlobalContext";
import { DESIGN_SECTIONS } from "../../../../features/cart/api/designStats";

const ImageModal = ({
  openModal,
  handleClose,
  data,
  nextClick,
  prevClick,
  isAdded,
  setIsAdded,
  hasNext,
  hasPrev,
}) => {
  const [zoomStyle, setZoomStyle] = useState({
    transform: "scale(1)",
    transformOrigin: "center",
  });

  const { handleAddToCart, handleRemoveFromCart, galleryView } =
    useGlobalContext();

  const handleMouseMove = useCallback((e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    setZoomStyle({
      transform: "scale(2.5)",
      transformOrigin: `${x}% ${y}%`,
    });
  }, []);

  const handleMouseLeave = useCallback(() => {
    setZoomStyle({ transform: "scale(1)", transformOrigin: "center" });
  }, []);

  const handleCartToggle = useCallback(() => {
    try {
      if (isAdded) {
        handleRemoveFromCart(data?.allData);
        // setIsAdded(false);
      } else {
        const itemToAdd = {
          ...data?.allData,
          sizeAvailable: false,
          // The popup re-adds a design that came from somewhere else, so it
          // carries that section over. A design opened straight from the image
          // viewer has none, and is counted as Other.
          addSection: data?.allData?.addSection || DESIGN_SECTIONS.OTHER,
          addedAt: data?.allData?.addedAt || new Date().toISOString(),
          quantityData: [
            {
              key: `${data?.allData?.styleNumber}-${Date.now()}`,
              itemSize: "",
              goldColor: "P",
              goldQty: "18",
              diaQty: "VS-GH",
              message: null,
            },
          ],
          quantity: 1,
        };
        handleAddToCart(itemToAdd);
        // setIsAdded(true);
      }
    } catch (error) {
      console.error("Error handling cart action:", error);
    }
  }, [
    isAdded,
    data?.allData,
    handleAddToCart,
    handleRemoveFromCart,
    setIsAdded,
  ]);

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "1vw",
      }}
    >
      <Slide
        direction="left"
        in={openModal}
        timeout={500}
        mountOnEnter
        unmountOnExit
      >
        <Box className="image-modal-body" marginX="auto">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none",
              msUserSelect: "none",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "1vw" }}>
              <Typography
                color={"#000"}
                fontSize={"1vw"}
                fontFamily={"Poppins"}
                fontWeight={"500"}
                marginTop={".5vw"}
              >
                {data?.styleNumber}
              </Typography>
              {!galleryView && (
                <Box
                  sx={{
                    cursor: "pointer",
                    "&:hover": { opacity: 0.8 },
                    display:window.location.pathname === "/order"?"none" :"flex",
                    alignItems: "center",
                  }}
                  onClick={handleCartToggle} 
                >
                  {getIcon(isAdded ? "RemoveIcon" : "AddIcon")}
                </Box>
              )}
            </Box>
            <Box display="flex" gap="1vw" alignItems="center">
              <Box
                sx={{
                  cursor: hasPrev ? "pointer" : "not-allowed",
                  opacity: hasPrev ? 1 : 0.5,
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={prevClick}
              >
                {getIcon("PrevIcon")}
              </Box>
              <Box
                sx={{
                  cursor: hasNext ? "pointer" : "not-allowed",
                  opacity: hasNext ? 1 : 0.5,
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={nextClick}
              >
                {getIcon("NextIcon")}
              </Box>
              <Box
                // className="modal-close"
                onClick={handleClose}
                sx={{ cursor: "pointer", display: "flex", alignItems: "center"}}
              >
                {getIcon("Cross", "big")}
              </Box>
            </Box>
          </Box>
          <Box
            className="image-container"
            sx={{
              marginTop:"1vw",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "90%",
              width: "100%",
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none",
              msUserSelect: "none",
            }}
          >
            <img
              src={data?.imgUrl || Image}
              alt={data?.styleNumber}
              height="100%"
              width="100%"
              onMouseMove={handleMouseMove}
              onMouseLeave={handleMouseLeave}
              style={{
                transition: "transform 0.2s ease-in-out",
                ...zoomStyle,
                userSelect: "none",
                WebkitUserSelect: "none",
                MozUserSelect: "none",
                msUserSelect: "none",
              }}
              loading="lazy"
            />
          </Box>
        </Box>
      </Slide>
    </Modal>
  );
};

export default React.memo(ImageModal);

